export default __webpack_public_path__ + "static/media/promo-how-far-will-fudge-go_01.981f9a34.jpg";